import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column } from 'material-table';
// import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
// import { RowDataLive } from 'src/reducers/liveorderfile';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import { RowDataManufactur } from 'src/reducers/manufactur';

import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Tooltip from '@material-ui/core/Tooltip';
import { IconButton } from '@material-ui/core';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreIcon from '@material-ui/icons/Restore';

interface TableState {
    columns: Array<Column<RowDataManufactur>>;
    data: RowDataManufactur[];
}

export interface MHoldOrderViewProps {
    mHoldOrderData: RowDataManufactur[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    submitRework: (column: Object) => void;
}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '10px'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        // iconPadding: {
        //     padding: '6px'
        // },
        iconClose: {
            position: 'absolute',
            right: 0
        },
        button: {
            margin: theme.spacing(1),
        },
        textArea: {
            display: 'flex',
            justifyContent: 'center',
            margin: '20px'
        }
    })
);

const MHoldOrderView: React.StatelessComponent<MHoldOrderViewProps> = (props) => {  
    const classes = useStyles({});

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [orderno, setOrderno] = React.useState('');
    const [msgApp, setMsgApp] = React.useState('');

    const popoverClick = (event: React.MouseEvent<HTMLButtonElement>, ordernumber: string) => {
        setOrderno(ordernumber);
        setAnchorEl(event.currentTarget);
    };

    const popoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [titleName, setTitle] = React.useState('');
    const [openDialog, setOpen] = React.useState(false);
    const handleClickOpen = (title: string) => {
        setMsgApp('');
        setTitle(title);
        setAnchorEl(null);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleSubmit = () => {
        setOpen(false);
        const columns = {
            columns: {
                caseno: orderno,
                ordaction: titleName,
                msg: msgApp.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
            },
            id: 'ordcr'
        };
        props.submitRework(columns);
    };
    const msgAppChange = (msgValue: string) => {
        setMsgApp(msgValue);
    };

    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Case No',
                field: 'orderno',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                },
            },
            //  {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         padding: '8px',
            //         fontSize: '12px'
            //     }
            // },
            {
                title: 'Customer Name',
                field: 'customername',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                }
            },
            {
                title: 'Uploaded On',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                },
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                   padding: '8px',
                    fontSize: '12px'
                },
            },
            {
                title: 'TAT',
                field: 'tat',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Due By',
                field: 'dueby',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                },
            },
            {
                title: 'Reason',
                field: 'qc_remarks',
                filtering: false,
                cellStyle: {
                    padding: '8px',
                    fontSize: '12px'
                }
            },
            {
                title: 'Action',
                field: 'orderno',
                filtering: false,
                export: false,
                render: rowData => (
                    <div style={{ margin: 'auto' }}>
                        <Tooltip title="View" placement="top">
                            <IconButton
                                aria-label="view"
                                onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}
                            // className={classes.iconPadding}
                            >
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Update" placement="top">
                            <IconButton
                                aria-label="update"
                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => popoverClick(event, rowData.orderno)}
                            // className={classes.iconPadding}
                            >
                                <BorderColorIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Download" placement="top">
                            <IconButton
                                aria-label="download"
                                onClick={() => props.onDownloadClick((JSON.parse(JSON.stringify(rowData)).fpath), (JSON.parse(JSON.stringify(rowData)).fname))}
                            // className={classes.iconPadding}
                            >
                                <CloudDownloadIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </div>
                ),
                cellStyle: {
                    padding: '0px',
                    textAlign: 'center'
                }
            },
        ],
        data: props.mHoldOrderData
    });
 
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                            <AutorenewIcon />
                        </Fab>
                    </div>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={popoverClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <div>
                            <Button
                                variant="contained"
                                color="secondary"
                                className={classes.button}
                                startIcon={<DeleteIcon />}
                                onClick={() => handleClickOpen('Cancel')}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                endIcon={<RestoreIcon />}
                                onClick={() => handleClickOpen('Restart')}
                            >
                                Re-start
                            </Button>
                        </div>
                    </Popover>
                    <Dialog
                        open={openDialog}
                        onClose={handleClose}
                        fullWidth
                        maxWidth="sm"
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{`${titleName}`}</DialogTitle>
                        <DialogContent dividers>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure to {`${titleName}`} this Order ?
                                <div className={classes.textArea}>
                                    <TextField
                                        id="outlined-multiline-static"
                                        label="Remarks"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        autoFocus
                                        // defaultValue="Default Value"
                                        variant="outlined"
                                        onChange={(event) => msgAppChange(event.target.value as string)}
                                        value={msgApp}
                                    />
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                No
                            </Button>
                            <Button onClick={handleSubmit} disabled={msgApp === ''} color="primary" autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <MaterialTable
                        icons={tableIcons}
                        title="Orders on Hold"
                        columns={state.columns}
                        data={props.mHoldOrderData}
                        localization={{
                            toolbar: {
                                nRowsSelected: '{0} order(s) selected',
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        options={{
                            // filtering: true,
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            sorting: true,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '10px',
                                textAlign: 'center'
                            },
                            exportButton: true,
                            exportAllData: true,
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default MHoldOrderView;



// WEBPACK FOOTER //
// ./src/components/layouts/MHoldOrderView.tsx